<div class="form-container">
    <img class="align-center" [src]="cvaUI_url + '/assets/images/ih_cva_combined_logo.svg'" alt="logo">
    @if (formNotSubmitted) {
    <h2 class="form-title">Practice Signup Form</h2>
    <div class="banner-wrapper">
        <img src="assets/images/signup-banner.png" class="img-fluid banner-img" alt="EOY Banner" />
    </div>
    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form">
        <div>
            <h3>Practice Manager or Representative Information</h3>
            <!-- <span class="sub-heading">Your practice is signing up for the EOY Medtech Special.</span> -->

        </div>
        <div class="form-grid">
            <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" (blur)="trimControl('name')">
                <mat-error *ngIf="signupForm.get('name')?.hasError('required')">Name is required</mat-error>
                <mat-error *ngIf="signupForm.get('name')?.hasError('pattern')">Only alpha characters
                    allowed</mat-error>
                <mat-error *ngIf="signupForm.get('name')?.hasError('maxlength')">Only 65 characters are
                    allowed</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" (blur)="trimControl('email')">
                <mat-error *ngIf="signupForm.get('email')?.hasError('required')">Email is required</mat-error>
                <mat-error *ngIf="signupForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
                <mat-error *ngIf="signupForm.get('email')?.hasError('maxlength')">Only 65 characters are
                    allowed</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Phone</mat-label>
                <input matInput formControlName="phone" (blur)="trimControl('phone')">
                <mat-error *ngIf="signupForm.get('phone')?.hasError('required')">Phone is required</mat-error>
                <mat-error *ngIf="signupForm.get('phone')?.hasError('pattern')">Enter a valid phone number (e.g.
                    +1234567890)</mat-error>

            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Facility ID</mat-label>
                <input matInput formControlName="practiceId" (blur)="trimControl('practiceId')" maxlength="15">
                <mat-error *ngIf="signupForm.get('practiceId')?.hasError('maxlength')">Only 15 characters are
                    allowed</mat-error>
                <mat-hint align="start">
                    <a class="me-1" [href]="FIND_MY_FACILITY_ID_ROUTE" target="_blank" rel="noopener noreferrer">Find my
                        Facility ID</a>
                </mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Facility Name</mat-label>
                <input matInput formControlName="practiceName" (blur)="trimControl('practiceName')" maxlength="100">
                <mat-error *ngIf="signupForm.get('practiceName')?.hasError('maxlength')">Only 100 characters are
                    allowed</mat-error>
                <mat-error *ngIf="signupForm.get('practiceName')?.hasError('required')">Facility name is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>IT Vendor</mat-label>
                <mat-select formControlName="itVendor">
                    <mat-option *ngFor="let vendor of vendorList" [value]="vendor">
                        {{vendor}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="full-row" *ngIf="signupForm.get('itVendor')?.value === 'Other'">
                <mat-label>IT Vendor Contact</mat-label>
                <input matInput formControlName="itVendorContact" (blur)="trimControl('itVendorContact')"
                    placeholder="IT Vendor Contact Details">
                <mat-error *ngIf="signupForm.get('itVendorContact')?.hasError('maxlength')">Only 100 characters are
                    allowed</mat-error>
            </mat-form-field>
        </div>

        <h3>Practitioner Details</h3>
        <div formArrayName="clinicians">
            <div *ngFor="let clinician of clinicians.controls; let i = index" [formGroupName]="i" class="form-row"
                [ngClass]="{ 'extra-top': i > 0 }">
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" (blur)="trimNestedControl(i, 'name')">
                    <mat-error *ngIf="clinician.get('name')?.hasError('required')">Name is
                        required</mat-error>
                    <mat-error *ngIf="clinician.get('name')?.hasError('pattern')">Only alpha characters
                        allowed</mat-error>
                    <mat-error *ngIf="clinician.get('name')?.hasError('maxlength')">Only 65 characters are
                        allowed</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>HPI</mat-label>
                    <input matInput formControlName="hpi" class="uppercase" (blur)="trimNestedControl(i, 'hpi')">
                    <mat-error *ngIf="clinician.get('hpi')?.hasError('required')">HPI is required</mat-error>
                    <mat-error *ngIf="clinician.get('hpi')?.hasError('pattern')">Only alphanumeric allowed</mat-error>
                    <mat-error *ngIf="clinician.get('hpi')?.hasError('maxlength')">Only 15 characters are
                        allowed</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" (blur)="trimNestedControl(i, 'email')">
                    <mat-error *ngIf="clinician.get('email')?.hasError('required')">Email is
                        required</mat-error>
                    <mat-error *ngIf="clinician.get('email')?.hasError('email')">Enter a valid email</mat-error>
                    <mat-error *ngIf="clinician.get('email')?.hasError('maxlength')">Only 65 characters are
                        allowed</mat-error>
                </mat-form-field>

                <button type="button" (click)="removeClinician(i)" class="no-button">
                    <i class="bi bi-trash3 text-danger pointer"></i>
                </button>
            </div>
        </div>

        <button mat-stroked-button color="primary" type="button" (click)="addClinician()">Add Practitioner</button>

        <h3>Add On</h3>
        <mat-checkbox formControlName="enableACC">
            <span class="text-lg">Register for ACC Workflow <sup class="text-primary">new</sup></span>
        </mat-checkbox>

        <h3>Consent</h3>
        <mat-checkbox formControlName="consentPrivacy">
            I have read and agree to the <a [href]="PRIVACY_POLICY_ROUTE" target="_blank"
                rel="noopener noreferrer">Privacy
                Policy</a>.
        </mat-checkbox>

        <mat-checkbox formControlName="consentUsage">
            I consent to the Clinical Virtual Assistant to be used and launched from within Medtech evolution,
            including
            all ALEX API available functionalities.
        </mat-checkbox>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Signature (Your Name)</mat-label>
            <input matInput formControlName="signature" (blur)="trimControl('signature')">
            <mat-error *ngIf="signupForm.get('signature')?.hasError('required')">Signature is required</mat-error>
            <mat-error *ngIf="signupForm.get('signature')?.hasError('pattern')">Only alpha characters
                allowed</mat-error>
            <mat-error *ngIf="signupForm.get('signature')?.hasError('maxlength')">Only 65 characters are
                allowed</mat-error>
        </mat-form-field>

        <div class="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
            <button mat-flat-button color="primary" type="submit">
                Submit
            </button>
            <img src="assets/images/footer-logo.png" class="footer-logo" alt="Health New Zealand Logo" />
        </div>

    </form>
    } @else {
    <h2 class="form-title mt-5">{{sucessMessage}}</h2>
    }
</div>